import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default (userId) => {
	const url = EndPoints.USER_DRAFTS.replace(':userId', userId);
	return fetch(Methods.GET, url, null, null, true);
};
